export const STEPPER_SIZES = ["small", "medium"] as const;
export const DEFAULT_STEPPER_SIZE = STEPPER_SIZES[1];
export type StepperSize = (typeof STEPPER_SIZES)[number];

export const STEPPER_VARIANTS = ["horizontal", "vertical"] as const;
export const DEFAULT_STEPPER_VARIANT = STEPPER_VARIANTS[0];
export type StepperVariant = (typeof STEPPER_VARIANTS)[number];
